import React, { FC } from 'react';
import { UpdateUserError } from '@bechtel/types';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { UserUpdateErrorProps } from './types';
import { FooterButtonStyled } from '../styled';

const getErrorMessage = (error: UserUpdateErrorProps['updateUserError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case UpdateUserError.NOT_FOUND:
      return <Trans>User not found.</Trans>;
    case UpdateUserError.INVALID_ROLE_ID:
      return <Trans>Invalid Roles.</Trans>;
    case UpdateUserError.INVALID_DISCIPLINE_ID:
      return <Trans>Invalid Disciplines.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const UserUpdateError: FC<UserUpdateErrorProps> = ({ updateUserError, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} data-testid="update-user-error" style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Update User Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(updateUserError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <FooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </FooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default UserUpdateError;
